import styled from "styled-components";

export const H3Heading = styled.h3`
  text-align: inherit;
  font-size: 22px;
  font-weight: 300;
`;

export const H2Heading = styled.h2`
  text-align: inherit;
  font-size: 
  font-size: 24px:
`;

export const H1Heading = styled.h1`
  text-align: inherit;
  font-size: 
  font-size: 26px:
`;

// export default { H3Heading, H2Heading, H1Heading };



// WEBPACK FOOTER //
// ./src/components/HeadingStyles.js